<template>
    <div class="homeBody">
        <div class="width_total_100 headerBg animateContent homeAnimate1">
            <div class="w_container">
                <div class="commonTop">
                    <OmpLink></OmpLink>
                </div>
                <div class="bannerPart">
                    <div class="line">
                        <img style="width:100px" src="https://escloud.digiwincloud.com/static/zh-TW/img/LINE.png" alt="line"/>
                        <p>掃描二維碼添加LINE</p>
                    </div>
                    <div style="padding-left: 120px;">
                        <div>大數據時代</div>
                        <p>讓商業分析更高效，決策更科學!</p>
                    </div>
                    <FreeTryButton @getFreeTryVisible="getVisible"></FreeTryButton>
                </div>
                <div class="instruction">
                    <div class="instruTitle">
                        <div>產品介紹</div>
                        <p>Product introduction</p>
                    </div>
                    <div class="instruContent">
                        <ul>
                            <li>
                                <div class="instruConPer">
                                    <div>一站式的數據管理分析平台</div>
                                    <p>支援鼎新WorkFlow ERP系統，可快速連接ERP報表，從報表資料連接到整合、處理、分析後，終端即可隨時掌握數據圖表，實現對數據的全面性管理，幫助企業各部門快速瞭解業務趨勢。</p>
                                </div>
                            </li>
                            <li>
                                <div class="instruConPer">
                                    <div>靈活易用的視覺化分析圖表</div>
                                    <p>預設經營層、業務層、財務層等範本供用戶選擇，不需專業培訓，一般用戶透過簡單推曳即可輕鬆完成多圖表、多角度的圖表製作，自己就能完成複雜的資料分析工作!</p>
                                </div>
                            </li>
                            <li>
                                <div class="instruConPer">
                                    <div>完善貼心的價值服務</div>
                                    <p>完善的售前產品安裝設定和售後服務體系，提供產品使用教學，協助用戶合理規劃並呈現讓您滿意的精美數據圖表</p>
                                </div>
                            </li>
                            <li>
                                <div class="instruConPer">
                                    <div>值得信賴的品牌背書</div>
                                    <p>《天下》雜誌2018年的上榜前2100家製造企業中，鼎新數智的產品方案覆蓋率高達69％，連續多年保持成長並穩居行業榜首。</p>
                                </div>
                            </li>
                            <div class="clear"></div>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <div class="width_total_100 animateContent homeAnimate2">
            <div class="w_container">
                <div class="quick">
                    <div class="instruTitle quickTitle">
                        <div>從快速數據接入到智慧資料分析，5步建構智造大腦</div>
                        <p>From Fast Data Access to Intelligent Data Analysis, Five Steps to Build Intelligent Brain</p>
                    </div>
                    <div class="quickContent">
                        <ul>
                            <li class="quickLi1">
                                <div class="quickConPer">
                                    <span>01</span>
                                    <div>數據來源</div>
                                    <p>多端資料獲取，方便快捷</p>
                                </div>
                            </li>
                            <li class="quickLi2">
                                <div class="quickConPer">
                                    <span>02</span>
                                    <div>數據整合</div>
                                    <p>數據分類邏輯，清晰明瞭</p>
                                </div>
                            </li>
                            <li class="quickLi3">
                                <div class="quickConPer">
                                    <span>03</span>
                                    <div>數據處理</div>
                                    <p>數據加密處理，資訊安全</p>
                                </div>
                            </li>
                            <li class="quickLi4">
                                <div class="quickConPer">
                                    <span>04</span>
                                    <div>圖表製作</div>
                                    <p>報表酷炫，製作簡單</p>
                                </div>
                            </li>
                            <li class="quickLi5">
                                <div class="quickConPer">
                                    <span>05</span>
                                    <div>可視化分析</div>
                                    <p>個性化定制，<br/>按角色許可權查看數據</p>
                                </div>
                            </li>
                            <div class="clear"></div>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <div class="width_total_100 proBottomBg animateContent homeAnimate3">
            <div class="w_container">
                <div class="instruTitle proMakeTitle animateTitle">
                    <div>產品定價</div>
                    <p>Product Pricing</p>
                </div>
                <div class="proMakeCon">
                    <div class="perProMake">
                        <div class="perProMakeCon">
                            <img src="https://escloud.digiwincloud.com/static/zh-TW/img/product_free.png" />
                            <div>免費體驗版</div>
                            <p>（ NT$ 0/月，使用期限14天 ）</p>
                            <span class="proLine"></span>
                            <ul>
                                <li>提供專屬的登入帳號</li>
                                <li>提供豐富的圖表模板{分析圖表、指標樹等}</li>
                                <li>支援使用者自行建立視覺化報表</li>
                            </ul>
                        </div>
                        <FreeTryButton @getFreeTryVisible="getVisible"></FreeTryButton>
                    </div>
                    <div class="perProMake">
                        <div class="perProMakeCon">
                            <img src="https://escloud.digiwincloud.com/static/zh-TW/img/product_pay.png" />
                            <div>付費版</div>
                            <p>（TBB-標準版軟體訂閱費：未稅價NT$ 42000/年，含5U；</p>
                            <p>TBB-WF圖說報表軟體訂閱費：未稅價NT$ 66000/年，含5U；</p>
                            <p>TBB-SM圖說報表軟體訂閱費：未稅價NT$ 30000/年，含3U）</p>
                            <span class="proLine"></span>
                            <ul>
                                <li>標準版提供ERP指標的資料串接,並同步資料庫</li>
                                <li>標準版支援使用者建立指標相關的視覺化圖表</li>
                                <li>ERP圖說報表提供【ERP標準週期性報表】資料串接,並同步資料庫</li>
                                <li>ERP圖說報表支援使用者自行新增資料匯入及建立視覺化圖表</li>
                                <li>提供完整的帳號使用權限控管</li>
                                <li>10G儲存容量</li>
                                <li>不斷更新豐富的圖表範本</li>
                                <li>每天小時級更新資料庫</li>
                                <li>享受完善的售前和售後服務</li>
                                <li>支援PC端、手機行動裝置(APP)</li>
                            </ul>
                        </div>
                        <a href="https://market.digiwincloud.com/dw-display/login?returnUrl=%2Fdw-display%2Fdw-product-details%3FgoodsCode%3DChartReport%26sellingStrategyCode%3D70328781193792" target="_blank" @click="toDwCloudMarket">立即購買</a>
                    </div>
                    <div class="clear"></div>
                </div>
                <Footer></Footer>
            </div>
        </div>
        <Control></Control>
        <FreeTry :visible.sync="freeTryVisible"></FreeTry>
    </div>
</template>
<script>
import "@/assets/css/w-style.css"

import OmpLink from "@/components/common/OmpLink.vue"
import Control from "@/components/common/Control.vue"
import Footer from "@/components/common/Footer.vue"
import FreeTryButton from "@/components/common/FreeTryButton.vue"
import FreeTry from "@/components/common/FreeTry.vue"

  export default {
    components: {
        OmpLink,
        Control,
        Footer,
        FreeTryButton,
        FreeTry
    },
    name: 'Home',
    data() {
      return {
        freeTryVisible: false
      }
    },
    created () {
        this.$http.post('/backend/web/record', {
            pageName: 'Home',
            contentName : ''
        }, {headers: { "Content-Type": "application/json" }})
        .then(function (response) {
            if(response.status == 200){
                console.log("success");
            }
        })
        .catch(function (error) {
            console.log(error)
        });
    },
    mounted () {
        this.homeTopAnimate() // 顶部动画
        this.homeScrollAnimate() // 滚动动画
    },
    methods: {
        homeTopAnimate() {
            var homeAnimate_show1=1;
            $(".homeBody").children(".animateContent").each(function() {
                if($(this).hasClass("homeAnimate1") &&  parseInt(homeAnimate_show1)){
                    homeAnimate_show1 = 0;
                    $(this).find(".bannerPart").delay(800).addClass('animated fadeInUp');
                    $(this).find(".instruContent li").delay(800).addClass('flipInX animated hinge3');
                }
            });
        },
        homeScrollAnimate() {
            var homeAnimate_show1=1,homeAnimate_show2=1,homeAnimate_show3=1;
            $(window).scroll(function(){
                var scrollTop = window.pageYOffset||document.documentElement.scrollTop||document.body.scrollTop|| 0;
                $(".homeBody").children(".animateContent").each(function() {
                    var srollh = $(this).offset().top-$(window).height()+$(this).height()/3;
                    if((scrollTop > srollh)){
                        if($(this).hasClass("homeAnimate2") &&  parseInt(homeAnimate_show2)){
                            homeAnimate_show2 = 0;
                            $(this).find(".quickLi1").stop().animate({"opacity":"1"},400);
                            $(this).find(".quickLi2").stop().delay(300).animate({"opacity":"1"},400);
                            $(this).find(".quickLi3").stop().delay(600).animate({"opacity":"1"},400);
                            $(this).find(".quickLi4").stop().delay(900).animate({"opacity":"1"},400);
                            $(this).find(".quickLi5").stop().delay(1200).animate({"opacity":"1"},400);
                        } else if($(this).hasClass("homeAnimate3") &&  parseInt(homeAnimate_show3)){
                            homeAnimate_show3 = 0;
                            $(this).find(".animateTitle").delay(800).addClass('animated bounceIn');
                            $(this).find(".perProMake:nth-child(1)").delay(800).addClass('animated bounceIn');
                            $(this).find(".perProMake:nth-child(2)").delay(800).addClass('animated bounceIn');
                            $(this).find(".perProMake").stop().animate({"opacity":"1"},400);
                            $(this).find(".animateTitle").stop().animate({"opacity":"1"},400);
                        }
                    }
                });
            });
        },
        getVisible(visible) {
            this.freeTryVisible = visible
        },
        toDwCloudMarket() {//跳转云市场次数埋点
            this.$http.post('/backend/web/record', {
                pageName: 'dwCloudMarket',
                contentName : ''
            })
            .then(function (response) {
                if(response.status == 200){
                    console.log("success");
                }
            })
            .catch(function (error) {
                console.log(error);
            });
        }
    }

  }
</script>



// WEBPACK FOOTER //
// src/components/Home.vue